import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const StyledBox = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${themeGet('zIndices.foreground')};
  border-top: ${themeGet('borders.1')} ${themeGet('colors.border')};
  background-color: ${themeGet('colors.background.card')};
  padding: ${themeGet('space.4')} ${themeGet('space.3')};
  text-align: center;
`;

interface Props {
  children: ReactNode;
}

const StickyFooter = ({ children }: Props) => (
  <StyledBox data-testid="STICKY_FOOTER">{children}</StyledBox>
);

export default StickyFooter;
